import { Plus, Trash2, X } from "lucide-react";
import AdminPageShell from "@/admin/AdminPageShell";
import { useAdminGalleryItems } from "@/admin/useAdminGalleryItems";

const AdminGallery = ({ title = "Gallery", description = "Manage gallery imagery (image-URL based for now)." }) => {
  const { items, editing, loading, openNew, close, save, remove, updateEditingField } = useAdminGalleryItems();

  return (
    <AdminPageShell
      title={title}
      description={description}
      actions={<button onClick={openNew} className="btn-solid-pearl btn-pill-sm" data-testid="admin-gallery-new-btn"><Plus size={14} /> Add Item</button>}
      testId="admin-gallery-page"
    >
      {editing && (
        <form onSubmit={save} className="neu-panel p-6 mb-8 space-y-4" data-testid="admin-gallery-form">
          <div className="flex items-center justify-between">
            <span className="eyebrow">New Item</span>
            <button type="button" onClick={close}><X size={18} /></button>
          </div>
          <input required placeholder="Title" value={editing.title} onChange={(e) => updateEditingField("title", e.target.value)} className="neu-inset w-full h-11 px-3" data-testid="admin-gallery-title-input" />
          <input required placeholder="Image URL" value={editing.image_url} onChange={(e) => updateEditingField("image_url", e.target.value)} className="neu-inset w-full h-11 px-3" data-testid="admin-gallery-url-input" />
          <div className="grid sm:grid-cols-2 gap-4">
            <input placeholder="Category" value={editing.category} onChange={(e) => updateEditingField("category", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-gallery-category-input" />
            <input placeholder="Brand (optional)" value={editing.brand} onChange={(e) => updateEditingField("brand", e.target.value)} className="neu-inset h-11 px-3" data-testid="admin-gallery-brand-input" />
          </div>
          <label className="flex items-center gap-2 text-small">
            <input type="checkbox" checked={editing.featured} onChange={(e) => updateEditingField("featured", e.target.checked)} /> Featured
          </label>
          <button type="submit" className="btn-solid-pearl" data-testid="admin-gallery-save-btn">Save</button>
        </form>
      )}

      {loading ? (
        <p className="text-small">Loading…</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
          {items.map((item) => (
            <div key={item.id} className="neu-surface overflow-hidden" data-testid={`admin-gallery-item-${item.id}`}>
              <div className="h-[140px] overflow-hidden"><img src={item.image_url} alt={item.title} className="w-full h-full object-cover" /></div>
              <div className="p-3 flex items-center justify-between gap-2">
                <span className="text-small truncate">{item.title}</span>
                <button onClick={() => remove(item.id)} data-testid={`admin-gallery-delete-${item.id}`}><Trash2 size={14} /></button>
              </div>
            </div>
          ))}
          {items.length === 0 && <p className="text-small">No items yet.</p>}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminGallery;
